import type { Effect, Reducer, Subscription } from "@umijs/max";
import type { SingleSubMerchantType } from "./data";
import {
  addSubMerchant,
  editSubMerchant,
  getSubMerchantPage,
  removeSubMerchant,
} from "./service";

export type SubMerchantState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleSubMerchantType[];
};

type SubMerchantModelType = {
  namespace: string;
  state: SubMerchantState;
  reducers: {
    SubMerchantReducer: Reducer<SubMerchantState>;
  };
  effects: {
    fetchSubMerchantPageEffect: Effect;
    refreshDataEffect: Effect;
    addSubMerchantEffect: Effect;
    editSubMerchantEffect: Effect;
    removeSubMerchantEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: "refreshDataEffect",
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const SubMerchantModel: SubMerchantModelType = {
  namespace: "subMerchant",
  state: {
    code: 0,
    type: "",
    message: "success",
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    SubMerchantReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as SubMerchantState;
    },
  },

  effects: {
    *fetchSubMerchantPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getSubMerchantPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: "SubMerchantReducer",
          payload: res,
        });
      } catch (e) {
        console.error("Fetch data failed:", e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.subMerchant.current);
      const pageSize = yield select((state: any) => state.subMerchant.pageSize);
      yield put({
        type: "fetchSubMerchantPageEffect",
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addSubMerchantEffect: createEffect(addSubMerchant),
    editSubMerchantEffect: createEffect(editSubMerchant),
    removeSubMerchantEffect: createEffect(removeSubMerchant),
  },

  subscriptions: {
    setup() {},
  },
};

export default SubMerchantModel;
